import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Navbarnft_global from "./Navbars/Navbarnft_global";
import Footer from "./Footer";
import placeholderImage from "../Images/placeholder.svg";
import gold from "../Images/tick_gold.png";
import blue from "../Images/tick_blue.png";
import { useApiList, collectionLink } from "./exploreData";
import "./ExplorePages.css";

const categories = ["All", "Art", "Gaming", "Membership", "Metaverse", "Utility"];

function Collectionsstate({ UserWallet, signMessage, logout }) {
  const [cat, setCat] = useState("All");
  const collections = useApiList("/rank");

  const rows = useMemo(
    () =>
      (collections || [])
        .filter((c) => cat === "All" || c.catogry === cat)
        .sort((a, b) => Number(a.rank) - Number(b.rank)),
    [collections, cat]
  );

  return (
    <>
      <Navbarnft_global UserWallet={UserWallet} signMessage={signMessage} logout={logout} URL={window.apiURL} />
      <div className="w3-container">
        <section className="ex-hero">
          <div className="w3-eyebrow">Rankings</div>
          <h1>Top <span className="w3-gradient-text">collections</span></h1>
          <p>Collection rankings with category, creator fee and sales activity.</p>
        </section>
        <div className="ex-cats">
          {categories.map((c) => (
            <button key={c} className={`ex-chip ${cat === c ? "is-active" : ""}`} style={{ color: "inherit", cursor: "pointer" }} onClick={() => setCat(c)}>
              {c}
            </button>
          ))}
        </div>
        {collections !== null && rows.length === 0 ? (
          <div className="ex-empty">No collections to rank yet.</div>
        ) : (
          <table className="ex-table">
            <thead>
              <tr><th>#</th><th>Collection</th><th>Category</th><th>Creator fee</th><th>Sales</th></tr>
            </thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c._id} className="ex-row">
                  <td>{c.rank}</td>
                  <td>
                    <Link to={collectionLink(c)} className="ex-who">
                      <img className="av" src={c.logoImage || placeholderImage} alt="" />
                      {c.name}
                      {c.tick === "gold" && <img className="tk" src={gold} alt="Sharia compliant" />}
                      {c.tick === "blue" && <img className="tk" src={blue} alt="Verified" />}
                    </Link>
                  </td>
                  <td>{c.catogry || "—"}</td>
                  <td>{c.fee ? `${c.fee}%` : "0%"}</td>
                  <td>{(c.sold_price || []).length}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Collectionsstate;
